module.exports = __webpack_public_path__ + "img/achievement3.8bf160e0.jpeg";